import { useMemo } from "react";
import useViewer from "./useViewer";

export default function useLocalizedOptionsConfiguration() {
  const {
    locale,
    company: { questionOptionsConfigurations },
  } = useViewer();

  const options = useMemo(
    () =>
      questionOptionsConfigurations.find(
        ({ locale: questionOptionLocale }) => questionOptionLocale === locale
      ),
    [locale]
  );

  return options;
}
